import React from 'react';
import {useStyles} from './helper';

const Credit = ({slot, live}) => {
    const classes = useStyles();
    const group_limits = [...slot, ...live].sort((a, b) => {
        if (a.currency.toLowerCase() < b.currency.toLowerCase()) {
            return -1;
          }
          if (a.currency.toLowerCase() > b.currency.toLowerCase()) {
            return 1;
          }
          return 0;
    });

    return (
        <div className={classes.root}>
            <div className={classes.wrap} style={{padding: '0 20px'}}>
                {
                    group_limits.map((item) => (
                        <span className={classes.helper} style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                            <div style={{width: '50%'}}>
                                {
                                    item.providers?.includes('ThreeOaks') && <span>GR-YELLOW</span>
                                }
                                {
                                    item.providers?.includes('Belatra') && <span>GR-GREEN</span>
                                }
                                {
                                    item.providers?.includes('Mascot') && <span>GR02-GREEN</span>
                                }
                                {
                                    item?.name
                                }
                            </div>
                            <div style={{width: '50%'}}>
                                <span style={{color: item.amount < 200000 ? 'red' : '#3cde0b'}}>
                                    {new Intl.NumberFormat('ru-RU').format(item.amount ? (+item?.amount).toFixed(2) : item.amount)} {item.currency}
                                </span>
                            </div>
                        </span>
                    ))
                }
            </div>
        </div> 
    )
}

export default Credit;